import styled from "styled-components";

export const LoginStyled = styled.main`
  display: flex;
  height: 100dvh;
  max-height: 100dvh;

  .LogoBranca {
    display: flex;
    width: 55%;
    justify-content: center;
    align-items: center;
    background: var(--background);
    box-shadow: 21px 0px 30px -20px rgba(0, 0, 0, 0.4);
    z-index: 2;
    img {
      width: 69vh;
    }
  }

  .formLogin {
    background: var(--cinza);
    width: 45%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .voltarWebview {
    position: absolute;
    top: 15px;
    height: 40px;
    width: 80px;
    border-radius: 0 20px 20px 0;
    background-color: var(--cor-primaria);
    justify-content: center;
    text-align: center;
    /* align-items: center; */
    padding: 5px;
    .APPGoBck {
      color: var(--branco);
      font-size: 30px;
      cursor: pointer;
    }
  }

  //Mobile
  /* Estilos para dispositivos móveis em modo retrato */
  @media only screen and (max-width: 800px) and (orientation: portrait) {
    .LogoBranca {
      display: none;
    }
    .formLogin {
      width: 100%;
    }
  }
`;

export const FormLoginStyled = styled.form`
  display: flex;
  flex-direction: column;
  border: 3px solid var(--cor-primaria);
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
  width: 55%;
  max-height: 100%;
  justify-content: space-around;
  border-radius: 10px;
  padding: 4% 0;
  gap: 35px;

  .formulario {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 35px;
    .logoLogin {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;

      .logoMobile {
        display: None;
      }

      img {
        width: 20%;
      }
    }

    .inputsLogin {
      display: flex;
      flex-direction: column;
      position: relative;
      justify-content: center;

      .inputSenha {
        position: relative;
        display: flex;
        align-items: center;
        margin: 0 20px;
      }

      .inputSenha input {
        flex: 1;
        padding-right: 40px; /* Espaço para o botão */
      }

      .toggleSenha {
        position: absolute;
        right: 10%;
        background: none;
        border: none;
        cursor: pointer;
        font-size: 1.2rem;
        color: var(--cor-contraste);
      }

      .toggleSenha:hover {
        color: var(--cor-primaria);
      }

      label {
        display: block;
        margin-bottom: 2%;
        font-size: 1.3rem;
        margin-left: 5%;
        color: var(--cor-contraste);
      }
      input {
        color: var(--cor-contraste);
        border-radius: 0.6rem;
        width: 90%;
        border: 2px solid var(--cor-primaria);
        margin: 0 auto;
        font-size: 1rem;
        padding: 4%;

        &::placeholder {
          color: var(--cor-contraste);
          opacity: 65%;
          font-size: 1.2rem;
        }
      }
      input:-webkit-autofill,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset;
      }

      input:focus {
        outline: none;
      }

      p {
        font-size: 15px;
        color: var(--cor-contraste);
        position: absolute;
        right: 5%;
        top: 110%;
      }
    }

    .botaoEntrar {
      display: flex;
      justify-content: center;

      button {
        font-size: 18px;
        background: var(--branco);
        border-radius: 3px;
        width: 70%;
        height: 40px;
        max-width: 100%;
        cursor: pointer;
        color: var(--cor-primaria);
        font-weight: bold;
        border: 2px solid var(--cor-primaria);
        transition: 0.3s;
      }

      button:disabled {
        background-color: var(--cor-primaria);
        color: var(--branco);
        cursor: not-allowed;
        opacity: 0.7;
      }

      button:disabled::after {
        content: " ";
        display: inline-block;
        margin-left: 10px;
        border: 2px solid white;
        border-top: 2px solid transparent;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        animation: spin 0.8s linear infinite;
      }

      button:hover {
        background: var(--degrade);
        color: var(--branco);
        border: 2px solid var(--cor-primaria);

        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
      }
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }

    .compyright {
      display: flex;
      justify-content: center;
      border-top: 2px solid var(--cor-primaria);
      padding-top: 10px;
      margin: 0 14px;

      span {
        font-size: 0.9em;
        color: var(--cor-contraste);
        opacity: 65%;
      }
    }
  }

  /* @media (min-width: 1600px) {
    width: 50%;
  } */

  //Mobile
  /* Estilos para dispositivos móveis em modo retrato */
  @media only screen and (max-width: 800px) and (orientation: portrait) {
    width: 80%;
    min-height: 55vh;

    .formulario {
      .logoLogin {
        .logoMobile {
          display: flex;
        }
        .logoDesktop {
          display: none;
        }
        img {
          width: 120px;
        }
      }

      .compyright {
        span {
          font-size: 0.7em;
        }
      }
    }
  }

  /* Estilos para dispositivos móveis em modo paisagem */
  @media only screen and (max-width: 940px) and (orientation: landscape) {
    width: 65%;
    /* max-height: 90%; */
    padding: 2% 0;
    /* margin: 15px; */
    gap: 15px;
    .formulario {
      gap: 8px;
      .logoLogin {
        img {
          width: 18%;
        }
        h2 {
          font-size: 1.2em;
        }
      }

      .inputsLogin {
        label {
          margin-bottom: 1.2%;
          font-size: 1rem;
        }
        input {
          font-size: 1rem;
          padding: 2.5%;

          &::placeholder {
            font-size: 1rem;
          }
        }
        p {
          font-size: 0.6em;
          top: 105%;
        }
      }
      .botaoEntrar {
        button {
          font-size: 1em;
          height: 30px;
        }
      }
      .compyright {
        padding-top: 5px;
        span {
          font-size: 0.5rem;
        }
      }
    }
  }
`;
